export default function (instance) {
  return {
    getTodaySchedule() {
      return instance.get("schedule/get/today?today=true");
    },
    getSchedule() {
      return instance.get("schedule/get/today");
    },
    getTraining(trainingId) {
      return instance.get(`schedule/${trainingId}`);
    },
  };
}
